// based off of code from https://github.com/intesso/decode-html
const entities = {
  amp: '&',
  apos: "'",
  lt: '<',
  gt: '>',
  quot: '"',
  nbsp: '\xa0',
} as const;
const entityPattern = /&([a-z]+);/gi;

export function decode(text: string): string {
  // A single replace pass with a static RegExp is faster than a loop
  return text.replace(entityPattern, function (match: string, entity: keyof typeof entities) {
    if (Object.prototype.hasOwnProperty.call(entities, entity)) {
      return entities[entity];
    }
    return match;
  });
}
